import Toggle from './toggle';

export default Toggle;

export { type ToggleProps } from './toggle';

export { default as toggleVariants, type ToggleVariantProps } from './variants';
